import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DonutChartComponent } from '@softapps/core/chart';
import { AnzahlMitarbeiterGesamtPipe } from '../../pipes/anzahl-mitarbeiter-gesamt.pipe';

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-abteilung-card',
  imports: [
    CommonModule,
    RouterLink,
    AnzahlMitarbeiterGesamtPipe,
    DonutChartComponent,
    LoadingSpinnerComponent,
    TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './abteilung-card.component.html',
  styleUrls: ['./abteilung-card.component.css'],
  animations: [
    trigger('animateIn', [
      transition(':enter', [
        style({ opacity: 0.5, width: 0 }),
        animate('300ms ease-in', style({ opacity: 1, width: '*' }))])])] })
export class AbteilungCardComponent {
  abteilung = input.required<any>();
  @Input() selected = false;
  @Input() mode: 'selection' | 'display' = 'display';
  @Output() tapped = new EventEmitter<void>();

  grid = input(false);

  abteilungStatusDasharrayData = computed(() => {
    const abteilung = this.abteilung();

    // Filter out "Abteilung" and "Vertrieb" from personen
    const filteredPersonen = abteilung.personen?.filter(
      (p) =>
        !p.vorname.toLowerCase().includes('abteilung') &&
        !p.vorname.toLowerCase().includes('vertrieb')
    );

    // Adjust total and abwesendRot
    const excludedCount = abteilung.personen?.length - filteredPersonen?.length;

    const anwesend = abteilung.status?.anwesend || 0;
    const abwesendRot = (abteilung.status?.abwesendrot || 0) - excludedCount;
    const abwesendGelb = abteilung.status?.abwesendgelb || 0;

    const total = anwesend + abwesendRot + abwesendGelb;

    const per1 = (anwesend / total) * 100;
    const per2 = (abwesendRot / total) * 100;
    const per3 = (abwesendGelb / total) * 100;
    const offset = 25;

    const anwesendDasharray = `${per1} ${100 - per1}`;
    const anwesendDasharrayOffset = offset;

    const abwesendRotDasharray = `${per2} ${100 - per2}`;
    const abwesendRotDasharrayOffset = 100 - per1 + offset;

    const abwesendGelbDasharray = `${per3} ${100 - per3}`;
    const abwesendGelbDasharrayOffset = 100 - (per1 + per2) + offset;

    return {
      total,
      anwesend: {
        number: anwesend,
        dasharray: anwesendDasharray,
        dasharrayOffset: anwesendDasharrayOffset },
      abwesendRot: {
        number: abwesendRot,
        dasharray: abwesendRotDasharray,
        dasharrayOffset: abwesendRotDasharrayOffset },
      abwesendGelb: {
        number: abwesendGelb,
        dasharray: abwesendGelbDasharray,
        dasharrayOffset: abwesendGelbDasharrayOffset } };
  });
}
